module.exports = __webpack_public_path__ + "static/media/logo-imagine_primary-main.b08e50d0.svg";